<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-plus"></i>
    </div>
    <div>
      <h2 class="dialog-title">New Streaming Creativity</h2>
      <p class="dialog-subtitle">Fill in the creativity details for {{ campaign.title }} ({{ campaign.agency | objectdesc }}/{{ campaign.commercialOffice| objectdesc }})</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="creativityForm" class="dialog-form-grid">
    <!-- Upload File Using -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Upload File Using <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="uploadMethod" placeholder="Select method" [compareWith]="comparatorService.compareById" (valueChange)="onChangeUploadMethod($event)">
          @for( method of uploadMethods; track method ) {
            <mat-option [value]="method">{{ method | objectdesc}}</mat-option>
          }
        </mat-select>
        @if( creativityForm.get('uploadMethod')?.hasError('required') ) {
          <mat-error>Upload method is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- File -->
    <file-selector style="display: none;" #multiFileSelectorHttp [fileFormControl]="$any(creativityForm.get('file'))" [label]="'Media File'" [required]="true" [multiple]="true" (fileSelected)="onSelectMultipleFilesHttp($event)"></file-selector>
    <aspera-file-selector style="display: none;" #multiFileSelectorAspera [fileFormControl]="$any(creativityForm.get('file'))" [label]="'Media File'" [required]="true" [multiple]="true" (fileSelected)="onSelectMultipleFilesAspera($event)"></aspera-file-selector>
  </form>

  <!-- Creativities Table with FormArray -->
  <div class="table-container">
    <div class="data-card">
      <div class="table-wrapper">
        <table mat-table [dataSource]="tableDataSource">

          <!-- Vertical Column -->
          <ng-container matColumnDef="vertical">
            <th mat-header-cell *matHeaderCellDef> Vertical </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <mat-form-field appearance="outline" class="table-form-field">
                <mat-select formControlName="vertical"
                            placeholder="Select vertical"
                            [compareWith]="comparatorService.compareById"
                            multiple
                            (valueChange)="onSelectChannelFamilies(row, $event)">
                  <mat-select-trigger>
                    @if (row.get('vertical')?.value?.length > 0) {
                      {{ row.get('vertical')?.value[0] | objectdesc }}
                      @if (row.get('vertical')?.value?.length > 1) {
                        <span class="additional-selection">
                          (+{{ row.get('vertical')?.value.length - 1 }}
                          {{ row.get('vertical')?.value.length === 2 ? 'other' : 'others' }})
                        </span>
                      }
                    }
                  </mat-select-trigger>
                  @for(vertical of channelFamilies; track vertical.id) {
                    <mat-option [value]="vertical">{{ vertical | objectdesc }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Format Column -->
          <ng-container matColumnDef="format">
            <th mat-header-cell *matHeaderCellDef> Format </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <mat-form-field appearance="outline" class="table-form-field">
                <mat-select formControlName="format"
                            placeholder="Select format"
                            [compareWith]="comparatorService.compareById">
                  @for(format of row.get('formatList')?.value; track format.id) {
                    <mat-option [value]="format">{{ format | objectdesc }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Country/Region Column -->
          <ng-container matColumnDef="countryRegion">
            <th mat-header-cell *matHeaderCellDef> Country/Region </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <mat-form-field appearance="outline" class="table-form-field">
                <mat-select formControlName="countryRegion"
                            placeholder="Select country"
                            [compareWith]="comparatorService.compareById"
                            multiple>
                  <mat-select-trigger>
                    @if (row.get('countryRegion')?.value?.length > 0) {
                      {{ row.get('countryRegion')?.value[0] | objectdesc }}
                      @if (row.get('countryRegion')?.value?.length > 1) {
                        <span class="additional-selection">
                          (+{{ row.get('countryRegion')?.value.length - 1 }}
                          {{ row.get('countryRegion')?.value.length === 2 ? 'other' : 'others' }})
                        </span>
                      }
                    }
                  </mat-select-trigger>
                  @for(country of countries; track country.id) {
                    <mat-option [value]="country">{{ country | objectdesc }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Placement Name Column -->
          <ng-container matColumnDef="placementName">
            <th mat-header-cell *matHeaderCellDef> Placement Name </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              <mat-form-field appearance="outline" class="table-form-field">
                <input matInput
                       formControlName="placementName"
                       placeholder="Enter placement name">
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Filename Column (Read-only) -->
          <ng-container matColumnDef="filename">
            <th mat-header-cell *matHeaderCellDef> Filename </th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
              @if( showHttpFileSelectors ) {
                <file-selector [fileFormControl]="$any(row.get('file'))" [showLabel]="false" [required]="true" [multiple]="false" (fileSelected)="onSelectFileHttp($event, row)"></file-selector>
              }
              @if( showAsperaFileSelectors ) {
                <aspera-file-selector [fileFormControl]="$any(row.get('file'))" [showLabel]="false" [required]="true" [multiple]="false" (fileSelected)="onSelectFileAspera($event, row)"></aspera-file-selector>
              }

              <!-- <mat-form-field appearance="outline" class="table-form-field">
                <input matInput
                       formControlName="filename"
                       placeholder="No file selected"
                       readonly>
              </mat-form-field> -->
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <div class="actions">
                <button matButton class="act-btn" (click)="onAddRow()" matTooltip="Add Row">
                  <i class="fa-solid fa-plus"></i>
                </button>
                @if( showAddFilesButton ) {
                  <button matButton class="act-btn" (click)="onAddFiles()" matTooltip="Add Files">
                    <i class="fa-solid fa-file-import"></i>
                  </button>
                }
              </div>
            </th>
            <td mat-cell *matCellDef="let row; let i = index">
              <div class="actions">
                <button matButton class="act-btn danger" (click)="onDeleteRow(i)" matTooltip="Delete">
                  <i class="fa-regular fa-trash-can"></i>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row
              *matRowDef="let row; columns: displayedColumns; let i = index"
              [class.invalid-row]="row.invalid && row.touched"></tr>
        </table>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue"
          (click)="onSubmit()"
          [disabled]="!creativityForm.valid || rows.length === 0">
    Create Creativities
  </button>
</mat-dialog-actions>
